import { Button, Col, Modal, Popconfirm, Row, Space, Tooltip, Input, Form } from 'antd';
import HTTPService from '../../../utils/makerequest';
import { IPageData } from '../../../interfaces/page-data';
import { useEffect, useRef, useState } from 'react';
import { StateLoader } from '../../../redux/StateLoader';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import '../PrinterManagement/Device.css';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import moment from 'moment';
import MUIDatagrid, { IMUIDataGridColumns } from '../../../AltisComponent/MUIDataGrid';
import { DeleteOutlined, EditOutlined, ExclamationCircleFilled, FileExcelOutlined, ToolOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Toast } from 'primereact/toast';
import CustomFilterInput from '../../../AltisComponent/CustomFilterInput';

const CareManagement: React.FunctionComponent<any> = (props) => {
    const { onSetPage } = props;
    const { t } = useTranslation();
    const loader = new StateLoader();
    const userInfo: IAuthentication = loader.loadAuthState();
    const [careData, setCareData] = useState({ data: [], count: 0 });
    const [careDetailData, setCareDetailData] = useState({ data: [], count: 0 });
    const dataGridRef = useRef<any>(null);
    const detailDataGridRef = useRef<any>(null);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [activityData, setActivityData] = useState<any[]>([]);
    const [selectedmaintenanceId, setSelectedmaintenanceId] = useState(null);
    const [newIsCompleted, setNewIsCompleted] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisibleDelete, setIsModalVisibleDelete] = useState(false)
    const [selectedCareId, setSelectedCareId] = useState<number | null>(null);
    const [completionDescription, setCompletionDescription] = useState('');
    const [isModalDetail, setIsModalDetail] = useState(false);
    const toast = useRef<Toast>(null);
    const [form] = Form.useForm();
    const [selectedDetailItems, setSelectedDetailItems] = useState<any[]>([]);
    const [isCompletionModalVisible, setIsCompletionModalVisible] = useState(false);
    const [selectedInventoryForCompletion, setSelectedInventoryForCompletion] = useState(null);
    const [columns, setColumns] = useState<IMUIDataGridColumns[]>([]);
    const [columnsDetail, setColumnsDetail] = useState<IMUIDataGridColumns[]>([]);
    const [currentMaintenanceId, setCurrentMaintenanceId] = useState<number | null>(null);
    const [completedMaintenanceIds, setCompletedMaintenanceIds] = useState<number[]>([]);

    const pageData: IPageData = {
        title: t('care'),
        loaded: true,
    };

    useEffect(() => {
        onSetPage(pageData);
        dataGridRef.current.GetAllData()
        ActivityFilter();
    }, [i18n.language]);

    useEffect(() => {
        // Ana kolonları ve detay kolonlarını ayarlayın
        setColumnsDetail([
            {
                title: t('inventoryName'),
                key: 'inventoryTBL.inventoryName',
                placeHolder: t('inventory_name'),
                width: 200,
                render: (value, record) => {
                    return <div style={{ textAlign: 'left' }}>
                        {record?.inventoryTBL?.inventoryName || '-'}
                    </div>;
                }
            },
            {
                title: t('barcode'),
                key: 'inventoryTBL.barcode',
                placeHolder: t('barcode'),
                align: 'center',
                headerAlign: 'center',
                width: 200,
                render: (value, record) => {
                    return <div style={{ textAlign: 'center' }}>
                        {record?.inventoryTBL?.barcode || '-'}
                    </div>;
                }
            },
            {
                title: t('maintenance_date'),
                key: 'dates',
                placeHolder: t('maintenance_date'),
                dataType: 'date',
                width: 100,
                isSorting: true,
                render: (value) => {
                    return moment(value).format('DD-MM-YYYY');
                }
            },
            {
                title: t('operations'),
                key: 'operations',
                placeHolder: t('operations'),
                headerAlign: 'center',
                isSorting: false,
                align: 'center',
                render: (_, record) => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    const maintenanceDate = new Date(record.dates);
                    maintenanceDate.setHours(0, 0, 0, 0);

                    const isDateValid = maintenanceDate <= today;

                    return (
                        <Button
                            size="small"
                            onClick={() => {
                                setSelectedInventoryForCompletion(record);
                                setIsCompletionModalVisible(true);
                            }}
                            disabled={record.isCompleted || !isDateValid}
                            style={{
                                backgroundColor: record.isCompleted ? '#f5f5f5' : undefined
                            }}
                        >
                            {record.isCompleted ? t('completed') : t('complete')}
                        </Button>
                    );
                },
            }
        ]);
    }, [t, i18n.language]); // i18n.language değiştiğinde kolonları güncelle

    const handleCancel = () => {
        setIsModalVisible(false);
        setCompletionDescription(''); // Clear the input value
    };

    const showModal = (id, currentStatus) => {
        setSelectedmaintenanceId(id);
        setNewIsCompleted(!currentStatus);
        setIsModalVisible(true);
    };

    const handleOk = () => {
        if (!completionDescription.trim()) {
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('description_required'),
                life: 3000
            });
            return;
        }
        handleCheckboxChange(selectedmaintenanceId, newIsCompleted, completionDescription);
        setCompletionDescription('');
        setIsModalVisible(false);
    };

    const handleCheckboxChange = async (id: number, isCompleted: boolean, description: string) => {
        try {
            const response = await HTTPService.PUT(
                `/Maintenance/isCompleted?maintenanceId=${id}&description=${encodeURIComponent(description)}`,
                {}
            );

            if (response.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: t('success'),
                    detail: t('update_success'),
                    life: 3000
                });
                dataGridRef.current.GetAllData();
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('update_failed'),
                    life: 3000
                });
            }
        } catch (error) {
            console.error('Error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const completeCare = async (inventoryId: number, maintenanceId: number, description: string) => {
        try {
            if (!description) {
                toast.current?.show({
                    severity: 'warn',
                    summary: t('Warning'),
                    detail: t('please_add_description'),
                    life: 3000
                });
                return;
            }

            const date = new Date();
            date.setHours(date.getHours() + 3);

            const requestBody = {
                completeMaintenance: [{
                    inventoryId,
                    maintenanceId,
                    actualMaintenanceDate: date.toISOString()
                }],
                companyId: userInfo?.companyId,
                description: description,
                dates: [selectedInventoryForCompletion.dates]
            };

            const response = await HTTPService.POST('/Maintenance/completeMaintenanceDetail', requestBody);

            if (response.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: t('success'),
                    detail: t('maintenance_completed_successfully'),
                    life: 3000
                });
                setIsCompletionModalVisible(false);
                form.resetFields(['completionDescription']);
                getCareId(maintenanceId);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('maintenance_completion_failed'),
                    life: 3000
                });
            }
        } catch (error) {
            console.error('Complete maintenance error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };



    const handleRowSelection = (newSelection: any) => {
        setSelectedRows(newSelection);
    };

    const handleDeleteClick = (maintenanceId: number) => {
        setSelectedmaintenanceId(maintenanceId);
        setIsModalVisibleDelete(true);
    };

    const CancelCare = (maintenanceId: number) => {
        if (!maintenanceId) {
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('invalid_maintenance_id'),
                life: 3000
            });
            return;
        }

        HTTPService.DELETE(`/Maintenance/deleteFaultRecord?maintenanceId=${maintenanceId}`).then(
            (response) => {
                if (response.status === 200) {
                    toast.current?.show({
                        severity: 'success',
                        summary: t('success'),
                        detail: t(response.data),
                        life: 3000
                    });
                    dataGridRef.current.GetAllData();
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t(response.data),
                        life: 3000
                    });
                }
            }
        ).catch(error => {
            console.error('Cancel Error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        });
    };

    const DeleteCare = (maintenanceId: number) => {
        if (!maintenanceId) {
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('invalid_maintenance_id'),
                life: 3000
            });
            return;
        }

        HTTPService.DELETE(`/Maintenance/deleteFault?maintenanceId=${maintenanceId}`).then(
            (response) => {
                if (response.status === 200) {
                    toast.current?.show({
                        severity: 'success',
                        summary: t('success'),
                        detail: t(response.data),
                        life: 3000
                    });
                    dataGridRef.current.GetAllData();
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t(response.data),
                        life: 3000
                    });
                }
            }
        ).catch(error => {
            console.error('Delete Error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        });
    };

    const getCareId = (maintenanceId: number, e?: any) => {
        const filters = e?.filters;
        let filterParams = [];

        filterParams.push(`maintenanceId=${maintenanceId}`);

        if (filters?.['inventoryTBL.inventoryName']) {
            filterParams.push(`inventoryName=${encodeURIComponent(filters['inventoryTBL.inventoryName'])}`);
        }

        if (filters?.['inventoryTBL.barcode']) {
            filterParams.push(`barcode=${encodeURIComponent(filters['inventoryTBL.barcode'])}`);
        }

        if (filters?.['dates']) {
            let dateValue = filters['dates'];
            if (Array.isArray(dateValue)) {
                dateValue = dateValue[0];
            }
            if (dateValue instanceof Date) {
                dateValue = moment(dateValue).format('YYYY-MM-DD');
            }
            filterParams.push(`dates=${encodeURIComponent(dateValue)}`);
        }


        const queryString = filterParams.join('&');

        HTTPService.GET(`/Maintenance/MaintenanceById?${queryString}`)
            .then((res) => {
                if (res.status === 200 && res.data) {

                    const filteredData = res.data.maintenanceDetailTBL.map(item => ({
                        ...item,
                        inventoryTBL: {
                            inventoryName: item.inventoryTBL?.inventoryName,
                            barcode: item.inventoryTBL?.barcode,
                            ...item.inventoryTBL
                        },
                        isSelected: false
                    }));

                    const hasCompletedMaintenance = filteredData.some(item => item.isCompleted);
                    if (hasCompletedMaintenance) {
                        setCompletedMaintenanceIds(prev => [...new Set([...prev, maintenanceId])]);
                    }

                    setCareDetailData({
                        data: filteredData,
                        count: filteredData.length
                    });

                    dataGridRef.current?.GetAllData();
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: res.error?.message || t('error_fetching_data'),
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching maintenance data:", error);
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('error_fetching_data'),
                    life: 3000
                });
            });
    };

    const ActivityFilter = (e?) => {
        HTTPService.GET(`/Activity/allActivityName?companyId=${userInfo?.companyId}`).then((response) => {
            if (!response.data) return;
            if (response.status === 200) {
                setActivityData(response.data);
            } else if (response.status === 450) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t(response.data),
                    life: 3000
                });
            }
        });
    };

    const priority = {
        [t('Low')]: 0,
        [t('Medium')]: 1,
        [t('High')]: 2,
        [t('Highest')]: 3
    }

    const columnss: IMUIDataGridColumns[] = [
        ...(userInfo.role == UserRole.AltisAdmin ? [{
            title: t('Company Name'),
            key: 'companyName',
            isSorting: true,
            placeHolder: t('Company Name'),
        }] : []),
        {
            title: t('activity_name'),
            key: 'activityId',
            placeHolder: t('activity_name'),
            isSorting: true,
            hideColumnMenu: true,
            render: (value) => {
                if (!Array.isArray(activityData)) return value;
                const activity = activityData?.find(a => a.activityId === value);
                return <div style={{ textAlign: 'left' }}>
                    {activity ? activity.activityName : value}
                </div>;
            }
        },
        {
            title: t('Priority'),
            key: 'priority',
            placeHolder: t('priority'),
            isSorting: true,
            headerAlign: 'left',
            align: 'left',
            enumValues: priority,
            render: (value) => {
                let iconColor = '';
                switch (value?.toLowerCase()) {
                    case 'low':
                        iconColor = '#52c41a'; // green
                        break;
                    case 'medium':
                        iconColor = '#faad14'; // yellow
                        break;
                    case 'high':
                        iconColor = '#ff4d4f'; // orange
                        break;
                    case 'highest':
                        iconColor = '#cc0000'; // red
                        break;
                    default:
                        iconColor = '#000000'; // black for unknown priority
                }

                return (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <ExclamationCircleFilled style={{
                            color: iconColor,
                            fontSize: '16px'
                        }} />
                        <span style={{ color: 'black' }}>{t(value)}</span>
                    </div>
                );
            }
        },
        {
            title: t('description'),
            key: 'description',
            placeHolder: t('description'),
            align: 'left',
        },
        // {
        //     title: t('careType'),
        //     key: 'maintenanceType',
        //     placeHolder: t('careType'),
        //     width: 180,
        //     render: (value) => {
        //         return <div style={{ textAlign: 'left' }}>{t(value)}</div>;
        //     }
        // },
        {
            title: t('maintenanceResponsible'),
            key: 'maintenanceExternalResponsibleName',
            placeHolder: t('maintenanceResponsible'),
        },
        {
            title: t('maintenanceStartDate'),
            key: 'maintenanceStartDate',
            placeHolder: t('maintenanceStartDate'),
            isSorting: true,
            dataType: 'date',
            render: (text) => {
                return moment(text).format('DD-MM-YYYY HH:mm')
            }
        },
        // {
        //     title: t('careCompleted'),
        //     key: 'careCompleted',
        //     placeHolder: t('careCompleted'),
        //     render: (text, record) => {
        //         return (
        //             <Tooltip title={record.isCompleted ? t('isCareMessageComp') : t('isCareMessage')}>
        //                 <Button
        //                     onClick={() => {
        //                         if (record && record.maintenanceId) {
        //                             showModal(record.maintenanceId, record.isCompleted);
        //                         } else {
        //                             console.error('Invalid record:', record);
        //                             toast.current?.show({
        //                                 severity: 'error',
        //                                 summary: t('errors'),
        //                                 detail: t('invalid_record'),
        //                                 life: 3000
        //                             });
        //                         }
        //                     }}
        //                     disabled={record.isCompleted}
        //                     size="small"
        //                 >
        //                     {record.isCompleted ? t('careCompleted') : t('completedStatus')}
        //                 </Button>
        //             </Tooltip>
        //         );
        //     },
        // },
        {
            title: t('operations'),
            key: 'operations',
            placeHolder: t('Operations'),
            isSorting: false,
            hideColumnMenu: true,
            render: (order, record) => {
                const canDelete = userInfo.role === UserRole.Admin || userInfo.role === UserRole.AltisAdmin;
                const isMaintenanceCompleted = completedMaintenanceIds.includes(record.maintenanceId);
                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                        <Space>
                            {canDelete && (
                                <Popconfirm
                                    title={t('are_you_sure_care')}
                                    onConfirm={() => {
                                        const idToDelete = record?.maintenanceId || record?.id;
                                        if (idToDelete) {
                                            DeleteCare(idToDelete);
                                        }
                                    }}
                                    okText={t('permanently_delete')}
                                    showCancel={false}
                                    disabled={record.isCompleted || isMaintenanceCompleted}
                                >
                                    <Tooltip title={t('delete')} placement="top">
                                        <Button
                                            size='small'
                                            icon={<DeleteOutlined />}
                                            style={{
                                                width: '60px',
                                                borderRadius: '70px',
                                            }}
                                            disabled={record.isCompleted || isMaintenanceCompleted}
                                        />
                                    </Tooltip>
                                </Popconfirm>
                            )}
                            <Tooltip title={t('details')} placement="top">
                                <Button
                                    size='small'
                                    icon={<UnorderedListOutlined />}
                                    style={{ width: '60px', borderRadius: '70px' }}
                                    onClick={() => {
                                        setIsModalDetail(true);
                                        setCurrentMaintenanceId(record.maintenanceId);
                                        getCareId(record.maintenanceId);
                                    }}
                                />
                            </Tooltip>
                            <Tooltip title={t('update')} placement="top">
                                <Button
                                    size='small'
                                    icon={<EditOutlined />}
                                    style={{
                                        display: userInfo.role === UserRole.Personel ? 'none' : 'inline-block',
                                        width: '60px',
                                        borderRadius: '70px'
                                    }}
                                    onClick={() => {
                                        window.location.replace(`/admin/update-care/${record.maintenanceId}`);
                                    }}
                                    disabled={record.isCompleted || isMaintenanceCompleted}
                                />
                            </Tooltip>
                        </Space>
                    </div>
                );
            },
        },
    ];


    const handleCancelDetail = () => {
        setIsModalDetail(false);
    }

    const handleDetailSelectionChange = (selectedDetailIds: number[]) => {
        const selectedItems = careDetailData.data.filter((item, index) =>
            selectedDetailIds.includes(index)
        );
        setSelectedDetailItems(selectedItems);
    };

    const CareFilter = (e?) => {
        const filters = e?.filters || {};

        if (filters?.maintenanceStartDate && Array.isArray(filters.maintenanceStartDate)) {
            const [startDate, endDate] = filters.maintenanceStartDate;
            filters.startDate_Start = startDate;
            filters.startDate_Finish = endDate;
            delete filters.maintenanceStartDate;
        }

        if (filters?.priority !== undefined) {
            if (filters.priority === "" || filters.priority === null) {
                delete filters.priority;
            } else {
                filters.priority = [Number(filters.priority)];
            }
        }

        const body = {
            sortColumn: e?.sortField || '',
            sortOrder: e?.sortOrder || 'asc',
            companyId: userInfo?.companyId,
            pageSize: e?.pageSize || 10,
            page: e?.page || 1,
            description: filters?.description || '',
            priority: filters?.priority ? [parseInt(filters.priority)] : null,
            activityId: filters?.activityId ? parseInt(filters.activityId) : null,
            maintenanceType: [1],
            maintenanceResponsible: filters?.maintenanceResponsible || '',
            startDate_Start: filters?.maintenanceStartDate ? new Date(filters.maintenanceStartDate).toISOString() : null,
            startDate_Finish: filters?.maintenanceStartDate ? new Date(filters.maintenanceStartDate).toISOString() : null,
            ...filters,
        };

        HTTPService.POST(`/Maintenance/filters`, body)
            .then((response) => {
                if (response.status === 200 && response.data) {
                    const formattedData = response.data.data.map(item => {

                        const hasCompletedDetail = item.maintenanceDetails?.includes(true)

                        if (hasCompletedDetail) {
                            setCompletedMaintenanceIds(prev =>
                                [...new Set([...prev, item.maintenanceId || item.id])]
                            );
                        }


                        return {
                            ...item,
                            maintenanceId: item.maintenanceId || item.id,
                            key: item.maintenanceId || item.id,
                            isAnyDetailCompleted: hasCompletedDetail
                        };
                    });

                    setCareData({
                        data: formattedData,
                        count: response.data.count
                    });
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t('error_message'),
                        life: 3000
                    });
                }
            });
    };


    const excelDownload = () => {
        const maintenanceIds = careData.data.map(item => item.maintenanceId);

        HTTPService.POSTblobExcelZip('/Maintenance/MaintenanceExcelDownloadReport', maintenanceIds)
            .then((response) => {
                if (response.status === 200) {
                    toast.current?.show({
                        severity: 'success',
                        summary: t('successful'),
                        detail: t('excelSuccess'),
                        life: 3000
                    });
                } else if (response.status === 452) {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('error'),
                        detail: t('licenceExpiredDate'),
                        life: 3000
                    });
                } else if (response.status === 453) {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('error'),
                        detail: t('licenceNotfound'),
                        life: 3000
                    });
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('error'),
                        detail: t(response.data),
                        life: 3000
                    });
                }
            })
            .catch((err) => {
                console.error(err);
                toast.current?.show({
                    severity: 'error',
                    summary: t('error'),
                    detail: t('error_message'),
                    life: 3000
                });
            });
    };

    return (
        <>
            <Toast ref={toast} />
            <Row gutter={16} style={{ marginTop: '20px' }}>
                <Col xs={24} sm={8} md={6} lg={4} xl={4} style={{ paddingLeft: '8px', display: 'flex', gap: '10px' }}>
                    <Button
                        type="primary"
                        shape="round"
                        style={{
                            height: 64,
                            width: 'auto',
                            backgroundColor: 'transparent',
                            color: '#1890ff',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '5px',
                            padding: 0,
                            border: 'none',
                            display: userInfo.role === UserRole.Personel ? 'none' : 'flex',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                            e.currentTarget.style.color = '#40a9ff';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                            e.currentTarget.style.color = '#1890ff';
                        }}
                        size="middle"
                        onClick={() => window.location.replace('/admin/add-care')}
                    >
                        <ToolOutlined style={{ fontSize: 24 }} />
                        <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                            {t('maintenanceAndFailure')}
                        </span>
                    </Button>

                    <Button
                        type="primary"
                        shape="round"
                        style={{
                            height: 64,
                            width: 'auto',
                            backgroundColor: 'transparent',
                            color: '#1890ff',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '5px',
                            padding: 0,
                            border: 'none',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                            e.currentTarget.style.color = '#40a9ff';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                            e.currentTarget.style.color = '#1890ff';
                        }}
                        size="middle"
                        icon={<FileExcelOutlined style={{ fontSize: 24 }} />}
                        onClick={excelDownload}
                    >
                        <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                            {t('download_excel')}
                        </span>
                    </Button>
                </Col>

                <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ marginTop: '10px', paddingLeft: '8px' }}>
                    <MUIDatagrid
                        ref={dataGridRef}
                        data={careData.data}
                        total={careData.count}
                        columns={columnss}
                        onSelectionChange={handleRowSelection}
                        enableSelection={false}
                        filterMode='server'
                        showStatusIcons={true}
                        onChange={CareFilter}
                    />
                </Col>
                <Modal
                    title={<span style={{ fontWeight: 'bold' }}>{t('completedStatus')}</span>}
                    visible={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    maskClosable={false}
                >
                    <p>{t('isCompletedModalMessage')}</p>
                    <Input
                        placeholder={t('enter_completion_description')}
                        value={completionDescription}
                        onChange={(e) => setCompletionDescription(e.target.value)}
                        style={{ marginTop: '16px' }}
                    />
                </Modal>

                <Modal
                    title={<span style={{ fontWeight: 'bold' }}>{t('details')}</span>}
                    visible={isModalDetail}
                    onCancel={handleCancelDetail}
                    footer={null}
                    width={800}
                    destroyOnClose={true}
                >
                    <div style={{ textAlign: 'left' }}>
                        <MUIDatagrid
                            ref={detailDataGridRef}
                            data={careDetailData.data}
                            total={careDetailData.count || 0}
                            columns={columnsDetail}
                            enableSelection={false}
                            showStatusIcons={true}
                            filterMode='server'
                            defaultPageSize={10}
                            onChange={(e) => getCareId(currentMaintenanceId, e)}
                        />
                    </div>
                </Modal>

                <Modal
                    title={<span style={{ fontWeight: 'bold' }}>{t('complete_maintenance')}</span>}
                    visible={isCompletionModalVisible}
                    onCancel={() => {
                        setIsCompletionModalVisible(false);
                        form.resetFields(['completionDescription']);
                        dataGridRef.current?.GetAllData();
                    }}
                    footer={null}
                    destroyOnClose={true}
                >
                    <Form
                        form={form}
                        onFinish={(values) => {
                            completeCare(
                                selectedInventoryForCompletion.inventoryId,
                                selectedInventoryForCompletion.maintenanceId,
                                values.completionDescription
                            );
                        }}
                    >
                        <Form.Item
                            name="completionDescription"
                            rules={[{ required: true, message: t('please_add_description') }]}
                        >
                            <Input
                                placeholder={t('enter_completion_description')}
                                style={{ borderRadius: '5px' }}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ borderRadius: '5px' }}
                            >
                                {t('complete')}
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            </Row>
        </>
    );
};

export default CareManagement;
